module.exports = __webpack_public_path__ + "img/MEDIA098.0af16f19.jpg";